import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {deleteReq, fetchData, fetchDataNew, fetchList} from "../../hook/axios.hook";
import {checkEmptyAndNullFields, checkEmptyFields} from "../../utilities/checkEmptyFields";
import {toaster} from "../../utilities/hooks/toaster";

const initialState = {
  skuList: [],
  importedSku: [],
  currentImportedSku: null,
  importedSkuFilters: null,
  skuPage: 0,
  totalPages: 0,
  // filterParams: null,
  currentSku: null,
  skuLoading: false,

  images: [],
  colorImages: [],
  decorImages: [],
  drawings: [],
  docs: [],
  imagesLoading: false,
  docsLoading: false,

  skuLoadingStatus: "idle",

  factories: [],
  countries: [],
  colors: [],
  measurementUnits: [],
  dimensions: [],
  materials: [],
  pallets: [],
  producrSeries: [],
  productGroups: [],
  productTypes: [],
  measurementObjects: [],

  volumeMeasurementQuantites: [],
  weightMeasurementQuantites: [],
  lengthMeasurementQuantites: [],
  areaMeasurementQuantites: [],
  measurementQuantites: {
    area: [],
    volume: [],
    weight: [],
  },
};

export const fetchSkuCatalogs = createAsyncThunk("sku/fetchSkuCatalogs", async () => {
  const responce = fetchList("/references/forSku", "get");
  return responce;
});

export const fetchSkuMeasureUnits = createAsyncThunk("sku/fetchSkuMeasureUnits", async () => {
  const responce = fetchList("/references/measurementUnits", "get");
  return responce;
});

export const fetchMeasurementQuantities = createAsyncThunk("sku/fetchMeasurementQuantities", async params => {
  const responce = fetchList("/references/measurementQuantities", "get", {params});
  return responce;
});

// export const fetchSkuBrands = createAsyncThunk("sku/fetchSkuBrands", async params => {
//   const responce = fetchList("/references/brands", "get", {params});
//   return responce;
// });

export const fetchSku = createAsyncThunk("sku/fetchSku", async ({signal, ...params} = {}, {rejectWithValue}) =>
  fetchDataNew("/sku/getAll", "get", {params, rejectWithValue, signal}),
);

export const getSkuInfo = createAsyncThunk("sku/getSkuInfo", async skuId => {
  const responce = fetchData(`/sku/get/${skuId}`, "get");
  return responce;
});

export const dublicateSku = createAsyncThunk("sku/dublicateSku", async skuId => {
  const responce = fetchData(`/sku/duplicate/${skuId}`, "post");
  return responce;
});

export const createSkuNumder = createAsyncThunk("sku/createSkuNumder", async () => {
  const responce = fetchData(`/sku/add`, "post");
  return responce;
});

export const createSku = createAsyncThunk("sku/createSku", async ({sku, skuId}) => {
  const responce = fetchData(`/sku/create/${skuId}`, "post", checkEmptyFields(sku));
  return responce;
});

export const updateSku = createAsyncThunk(
  "sku/updateSku",
  async ({sku, skuId, isHardUpdate, noMessage}, {rejectWithValue, signal}) => {
    return fetchDataNew(`/sku/update/${skuId}${isHardUpdate ? "?isHardUpdate=true" : ""}`, "patch", {
      body: {...checkEmptyFields(sku), articleColor: sku?.articleColor},
      noMessage: noMessage,
      rejectWithValue,
      signal,
    });
  },
);

export const createSkuPrices = createAsyncThunk("sku/createSkuPrices", async ({sku, skuId, noMessage}) =>
  fetchData(`/sku/create/${skuId}/price`, "post", checkEmptyAndNullFields(sku), null, false, null, noMessage),
);

export const updateSkuPrices = createAsyncThunk("sku/updateSkuPrices", async ({sku, skuId, noMessage}) =>
  fetchData(`/sku/update/${skuId}/price`, "patch", checkEmptyAndNullFields(sku), null, false, null, noMessage),
);

export const updateSkuVWC = createAsyncThunk("sku/updateSkuVWC", async ({sku, skuId, noMessage}) =>
  fetchDataNew(`/sku/update/${skuId}/dimension`, "patch", {rawBody: sku, noMessage}),
);

export const deleteSku = createAsyncThunk("sku/deleteSku", async ({skuId, force = 0}, {rejectWithValue}) => {
  const responce = fetchDataNew(`/sku/delete/${skuId}`, "delete", {params: {force}, rejectWithValue});
  return responce;
});

export const addSkuImages = createAsyncThunk("sku/addSkuImages", async ({skuId, formdata, noMessage}) => {
  const responce = fetchDataNew(`/sku/images/update/${skuId}`, "put", {body: formdata, noMessage});
  return responce;
});

export const delSkuImages = createAsyncThunk("sku/delSkuImages", async imageId => {
  const responce = deleteReq(`/sku/images/delete/${imageId}`);
  return responce;
});
export const addDecorImages = createAsyncThunk("sku/addDecorImages", async ({skuId, formdata, noMessage}) => {
  const responce = fetchDataNew(`/sku/decorImages/update/${skuId}`, "put", {body: formdata, noMessage});
  return responce;
});

export const delDecorImages = createAsyncThunk("sku/delDecorImages", async imageId => {
  const responce = deleteReq(`/sku/decorImages/delete/${imageId}`);
  return responce;
});

export const addColorImages = createAsyncThunk("sku/addColorImages", async ({skuId, formdata, noMessage}) => {
  const responce = fetchDataNew(`/sku/colorImages/update/${skuId}`, "put", {body: formdata, noMessage});
  return responce;
});

export const delColorImages = createAsyncThunk("sku/delColorImages", async imageId => {
  const responce = deleteReq(`/sku/colorImages/delete/${imageId}`);
  return responce;
});

export const addDrawingImages = createAsyncThunk("sku/addDrawingImages", async ({skuId, formdata, noMessage}) => {
  const responce = fetchDataNew(`/sku/drawings/update/${skuId}`, "put", {body: formdata, noMessage});
  return responce;
});

export const delDrawingImages = createAsyncThunk("sku/delDrawingImages", async imageId => {
  const responce = deleteReq(`/sku/drawings/delete/${imageId}`);
  return responce;
});

export const fetchSkuDocs = createAsyncThunk("sku/fetchSkuDocs", async skuId => {
  const responce = fetchDataNew(`/sku/docs/${skuId}`, "get");
  return responce;
});

export const addSkuDocs = createAsyncThunk("sku/addSkuDocs", async ({skuId, formdata, noMessage}) => {
  const responce = fetchDataNew(`/sku/docs/${skuId}`, "patch", {body: formdata, noMessage});
  return responce;
});

export const deleteSkuDoc = createAsyncThunk("sku/deleteSkuDoc", async docId => {
  const responce = fetchDataNew(`/sku/docs/${docId}`, "delete");
  return responce;
});

export const addSkuColor = createAsyncThunk("sku/addSkuColor", async ({name, engName}) => {
  return fetchDataNew(`/sku/color/add`, "post", {rawBody: {name, engName, withooutError: true}});
});
export const deleteSkuColor = createAsyncThunk("sku/deleteSkuColor", async colorId => {
  return fetchDataNew(`/sku/color/delete/${colorId}`, "delete");
});
export const addSkuMaterial = createAsyncThunk("sku/addSkuMaterial", async ({name, engName}) => {
  return fetchDataNew(`/sku/material/add`, "post", {rawBody: {name, engName, withooutError: true}});
});
export const deleteSkuMaterial = createAsyncThunk("sku/deleteSkuMaterial", async materialId => {
  return fetchDataNew(`/sku/material/delete/${materialId}`, "delete");
});
export const getImportedSku = createAsyncThunk("skuImported/allSku", async (params, {signal, rejectWithValue}) => {
  return fetchDataNew("skuImported", "get", {params, signal, rejectWithValue});
});
export const getImportedSkuById = createAsyncThunk("skuImported/skuById", async skuId => {
  return fetchDataNew(`skuImported/${skuId}`, "get");
});
export const updateImportedSku = createAsyncThunk("skuImported/createSku", async ({skuId, finitureId, ...body}) => {
  return fetchDataNew(`skuImported/${skuId}/${finitureId}`, "post", {body});
});
export const getFilterImportedSku = createAsyncThunk("skuImported/getFilters", async params => {
  return fetchDataNew("skuImported/filters", "get", params);
});

function sortByPropertyName(arr) {
  arr.sort(function (a, b) {
    var nameA = a.name.replace(/"/g, "").toUpperCase();
    var nameB = b.name.replace(/"/g, "").toUpperCase();
    if (nameA < nameB) {
      return -1; // Если первое имя меньше второго
    }
    if (nameA > nameB) {
      return 1; // Если первое имя больше второго
    }
    return 0; // Если имена равны
  });
  return arr;
}

const normalizeSkuDocs = payload => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.docs)) return payload.docs;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.files)) return payload.files;
  return [];
};

const skuSlice = createSlice({
  name: "sku",
  initialState,
  reducers: {
    deselectSku: state => {
      state.currentSku = null;
      state.images = [];
      state.colorImages = [];
      state.decorImages = [];
      state.drawings = [];
      state.docs = [];
    },
    changeSkuPage: (state, action) => {
      state.skuPage = action.payload;
    },
    setCurrentSku: (state, action) => {
      state.currentSku = action.payload;
    },
    setCurrentSkuImages: (state, {payload}) => {
      state.images = payload.images;
      state.colorImages = payload.colorImages;
      state.decorImages = payload.decorImages;
      state.drawings = payload.drawings;
      state.overallImages = payload.overallImages;
      state.docs = payload.docs || [];
    },
    changeSkuInSkuList: (state, {payload}) => {
      state.skuList = state.skuList?.map(sku => {
        if (sku?.skuId === payload?.skuId) {
          return payload;
        }
        return sku;
      });
    },
    setClearImportedSku: state => {
      state.importedSku = [];
      state.currentImportedSku = null;
    },
    // setFilters: (state, action) => {
    //   state.filterParams = action.payload;
    // },
    // selectSku: (state, action) => {},
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSkuCatalogs.pending, state => {
        state.skuLoadingStatus = "loading";
      })
      .addCase(fetchSkuCatalogs.fulfilled, (state, {payload}) => {
        state.skuLoadingStatus = "complete";
        Object.assign(state, payload);
        sortByPropertyName(state.colors);
      })
      .addCase(fetchSkuCatalogs.rejected, state => {
        state.skuLoadingStatus = "error";
      })
      //
      // .addCase(fetchSkuBrands.fulfilled, (state, {payload}) => {
      //   state.brands = payload.map(item => {
      //     return {title: item.name, value: item.brandId};
      //   });
      // })
      // .addCase(fetchSkuBrands.rejected, state => {
      //   state.brands = [];
      // })
      //
      .addCase(fetchSkuMeasureUnits.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.measurementUnits = payload.map(item => {
          return {value: item.name, unitId: item.unitId};
        });
      })
      .addCase(fetchSku.pending, state => {
        state.skuLoadingStatus = "loading";
      })
      .addCase(fetchSku.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.skuLoadingStatus = "idle";
          return;
        }
        state.skuLoadingStatus = "complete";
        const {sku, currentPage} = payload;
        state.skuList = currentPage > 1 ? [...state.skuList, ...sku] : sku;
      })
      .addCase(fetchSku.rejected, state => {
        state.skuLoadingStatus = "error";
      })

      .addCase(updateSku.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const normalizedSku = payload?.sku ?? payload;
        if (!normalizedSku) return;
        state.skuList = state.skuList?.map(item => {
          if (item?.skuId === normalizedSku.skuId) {
            return {...item, ...normalizedSku};
          } else return item;
        });
        const {factory, color, material, measurementUnit, pallet, productGroup, productType, ...rest} = normalizedSku;
        state.currentSku = {
          ...rest,
          factoryId: factory?.factoryId,
          factory,
          colorId: color?.colorId || "",
          materialId: material?.materialId || "",
          unitId: measurementUnit?.unitId || "",
          palletId: pallet?.palletId || "",
          productGroupId: productGroup?.productGroupId,
          productTypeId: productType?.productTypeId,
        };
      })
      .addCase(updateSkuVWC.fulfilled, (state, {payload}) => {
        const sku = payload;
        if (!sku) return;

        state.skuList = state.skuList?.map(item => {
          if (item?.skuId === sku.skuId) {
            return {...item, ...sku};
          } else return item;
        });

        state.currentSku = {
          ...state.currentSku,
          ...sku,
        };
      })
      .addCase(createSkuPrices.fulfilled, (state, {payload}) => {
        const sku = payload;
        if (!sku) return;

        state.skuList = state.skuList?.map(item => {
          if (item?.skuId === sku.skuId) {
            return {...item, ...sku};
          } else return item;
        });
        state.currentSku = {
          ...state.currentSku,
          ...sku,
        };
      })
      .addCase(updateSkuPrices.fulfilled, (state, {payload}) => {
        const sku = payload;
        if (!sku) return;
        state.skuList = state.skuList?.map(item => {
          if (item?.skuId === sku.skuId) {
            return {...item, ...sku};
          } else return item;
        });
        state.currentSku = {
          ...state.currentSku,
          ...sku,
        };
      })
      .addCase(updateSku.rejected, (state, {error}) => {
        toaster.error(typeof error === "string" ? error : error?.message || "Error");
      })
      .addCase(dublicateSku.fulfilled, (state, action) => {
        const {payload, meta} = action;
        if (!payload) return;

        const sku = state.skuList?.find(s => s?.skuId === meta.arg);
        state.skuList?.unshift({...sku, skuId: payload?.sku?.skuId});
        state.currentSku = payload?.sku;
        state.images = payload?.sku?.images || [];
        state.colorImages = payload?.sku?.colorImages || [];
        state.decorImages = payload?.sku?.decorImages || [];
        state.drawings = payload.sku?.drawings || [];
      })
      .addCase(createSkuNumder.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentSku = {skuId: payload?.id};
      })
      .addCase(createSku.fulfilled, (state, {payload}) => {
        if (!payload) return;
        const {sku} = payload;
        state.skuList.unshift(sku);
        const {factory, color, material, measurementUnit, pallet, productGroup, productType, ...rest} = sku;
        state.currentSku = {
          ...rest,
          factoryId: factory?.factoryId,
          factory,
          colorId: color?.colorId,
          materialId: material?.materialId,
          unitId: measurementUnit?.unitId || "",
          palletId: pallet?.palletId || "",
          productGroupId: productGroup?.productGroupId,
          productTypeId: productType?.productTypeId,
        };
      })
      .addCase(deleteSku.fulfilled, (state, action) => {
        const {meta} = action;
        state.currentSku = null;
        state.skuList = state.skuList?.filter(sku => sku?.skuId !== meta.arg.skuId);
        state.images = [];
        state.colorImages = [];
        state.decorImages = [];
        state.drawings = [];
        state.docs = [];
      })
      .addCase(getSkuInfo.pending, state => {
        state.skuLoading = true;
      })
      .addCase(getSkuInfo.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.skuLoading = false;
          return;
        }

        const {images, colorImages, decorImages, drawings} = payload;
        state.currentSku = payload;
        state.images = images;
        state.colorImages = colorImages;
        state.decorImages = decorImages;
        state.drawings = drawings;
        state.docs = [];
        state.skuLoading = false;
      })
      .addCase(getSkuInfo.rejected, state => {
        state.skuLoading = false;
      })
      .addCase(addSkuImages.pending, state => {
        state.imagesLoading = true;
      })
      .addCase(addSkuImages.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imagesLoading = false;
          return;
        }

        state.images = payload.images;

        state.imagesLoading = false;
      })
      .addCase(delSkuImages.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.images = payload.images;
      })
      .addCase(addDecorImages.pending, state => {
        state.imagesLoading = true;
      })
      .addCase(addDecorImages.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imagesLoading = false;
          return;
        }

        state.decorImages = payload.decorImages;
        state.imagesLoading = false;
      })
      .addCase(delDecorImages.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.decorImages = payload.decorImages;
      })
      .addCase(addColorImages.pending, state => {
        state.imagesLoading = true;
      })
      .addCase(addColorImages.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imagesLoading = false;
          return;
        }

        state.colorImages = payload.colorImages;
        state.imagesLoading = false;
      })
      .addCase(delColorImages.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.colorImages = payload.colorImages;
      })
      .addCase(addDrawingImages.pending, state => {
        state.imagesLoading = true;
      })
      .addCase(addDrawingImages.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imagesLoading = false;
          return;
        }

        state.drawings = payload.drawings;
        state.imagesLoading = false;
      })
      .addCase(delDrawingImages.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.drawings = payload.drawings;
      })
      .addCase(fetchSkuDocs.pending, state => {
        state.docsLoading = true;
      })
      .addCase(fetchSkuDocs.fulfilled, (state, {payload}) => {
        state.docsLoading = false;
        state.docs = normalizeSkuDocs(payload);
      })
      .addCase(fetchSkuDocs.rejected, state => {
        state.docsLoading = false;
      })
      .addCase(addSkuDocs.pending, state => {
        state.docsLoading = true;
      })
      .addCase(addSkuDocs.fulfilled, state => {
        state.docsLoading = false;
      })
      .addCase(addSkuDocs.rejected, state => {
        state.docsLoading = false;
      })
      .addCase(deleteSkuDoc.pending, state => {
        state.docsLoading = true;
      })
      .addCase(deleteSkuDoc.fulfilled, state => {
        state.docsLoading = false;
      })
      .addCase(deleteSkuDoc.rejected, state => {
        state.docsLoading = false;
      })

      .addCase(fetchMeasurementQuantities.fulfilled, (state, {meta, payload}) => {
        state[meta.arg.field + "MeasurementQuantites"] = payload;
      })

      .addCase(addSkuColor.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.colors = [payload, ...state.colors];
      })
      .addCase(deleteSkuColor.fulfilled, (state, {meta: {arg}}) => {
        state.colors = state.colors.filter(color => color.colorId !== arg);
      })
      .addCase(addSkuMaterial.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.materials = [payload, ...state.materials];
      })
      .addCase(deleteSkuMaterial.fulfilled, (state, {meta: {arg}}) => {
        state.materials = state.materials.filter(color => color.materialId !== arg);
      })
      .addCase(getImportedSku.fulfilled, (state, {payload}) => {
        if (!payload?.data) return;

        state.importedSku = payload.currentPage > 1 ? [...state.importedSku, ...payload.data] : payload.data;
      })
      .addCase(getImportedSkuById.fulfilled, (state, {payload}) => {
        state.currentImportedSku = payload;
      })
      .addCase(updateImportedSku.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.currentImportedSku = {
          ...state.currentImportedSku,
          ...payload,
          variants: state.currentImportedSku.variants?.map(variant =>
            variant.finiture?.finitureCode === payload.articleColor
              ? {
                  ...variant,
                  skuId: payload.skuId,
                }
              : variant,
          ),
        };
      })
      .addCase(getFilterImportedSku.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.importedSkuFilters = payload;
      })
      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = skuSlice;

export default reducer;
export const {
  deselectSku,
  changeSkuPage,
  setFilters,
  setCurrentSku,
  setCurrentSkuImages,
  changeSkuInSkuList,
  setClearImportedSku,
} = actions;

export const getCurrentSku = state => state.sku.currentSku;
export const getSkuLoading = state => state.sku.skuLoadingStatus;
export const getSkuList = state => state.sku.skuList;
export const selectSkuLoading = state => state.sku.skuLoading;

export const getCurrentPage = state => state.sku.skuPage;
export const getTotalPages = state => state.sku.totalPages;
// export const getFilterParams = state => state.sku.filterParams;

export const getColorImages = state => state.sku.colorImages;
export const getDecorImages = state => state.sku.decorImages;
export const getSkuImages = state => state.sku.images;
export const getDrawings = state => state.sku.drawings;
export const selectOverallImages = state => state.sku.overallImages;
export const getImagesLoading = state => state.sku.imagesLoading;
export const getSkuDocs = state => state.sku.docs;
export const getSkuDocsLoading = state => state.sku.docsLoading;

export const selectImportedSku = state => state.sku.importedSku;
export const selectCurrentImportedSku = state => state.sku.currentImportedSku;
export const selectImportedSkuFilters = state => state.sku.importedSkuFilters;
